// extracted by mini-css-extract-plugin
export default {"productDescription":"iaa-z","featuredDescription":"jaa-z","description":"kaa-z","more":"laa-z","descriptionSku":"maa-z"};